var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"back",attrs:{"icon":""},on:{"click":function($event){$event.preventDefault();return _vm.back()}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }